import { render, staticRenderFns } from "./yktDetail.vue?vue&type=template&id=db1af164&scoped=true&"
import script from "./yktDetail.vue?vue&type=script&lang=js&"
export * from "./yktDetail.vue?vue&type=script&lang=js&"
import style0 from "./yktDetail.vue?vue&type=style&index=0&id=db1af164&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1af164",
  null
  
)

export default component.exports